import React from "react";
import "./invoiceBill.scss";
import dateformat from "dateformat";
import { Box, Divider } from "@mui/material";

import CurrencyRupeeRoundedIcon from "@mui/icons-material/CurrencyRupeeRounded";

const InvoiceBill = ({ orderDetails }) => {
  return (
    <div className="invoice-bill">
      <div className="header">
        <h1>KRISTIVE</h1>
        <div className="header-left">
          <p>Bill of Supply / Cash Memo</p>
          <p className="original-recipient">(Original for Recipient)</p>
          <div className="bill-date">
            <b>Bill Date:</b> &nbsp; &nbsp;
            {dateformat(new Date(orderDetails.payment_at), "dd mmm yyyy")}
          </div>
        </div>
      </div>
      <Divider sx={{ mt: 2 }} />
      <div className="bill-content">
        <div className="addresses">
          <div className="our-address-info">
            <h4 className="title">Our Address</h4>
            <div className="our-name">KRISTIVE</div>
            <div className="our-address">
              {orderDetails.shippingAddress.address},<br />
              {orderDetails.shippingAddress.city},{" "}
              {orderDetails.shippingAddress.state} -
              {orderDetails.shippingAddress.pincode}
            </div>
            <div className="our-contact-no">
              {orderDetails.shippingAddress.phoneNumber}
            </div>
          </div>
          <div className="shipping">
            <h4 className="title">Shipping Address</h4>
            <div className="shipping-customer-name">
              {orderDetails.shippingAddress.fullName}
            </div>
            <div className="shipping-address">
              {orderDetails.shippingAddress.address},<br />
              {orderDetails.shippingAddress.city},{" "}
              {orderDetails.shippingAddress.state} -
              {orderDetails.shippingAddress.pincode}
            </div>
            <div className="shipping-customer-contact-no">
              {orderDetails.shippingAddress.phoneNumber}
            </div>
          </div>
        </div>

        <div className="order-product-details-table">
          <table className="order-table">
            <thead className="thead">
              <tr>
                <th colSpan={5}>
                  <Divider sx={{ mb: 0.3 }} />
                </th>
              </tr>
              <tr>
                <th>S.No</th>
                <th align="left">
                  <p>Item</p>
                </th>
                <th>QTY</th>
                <th>Price</th>
                <th>Amount</th>
              </tr>
              <tr>
                <th colSpan={5}>
                  <Divider sx={{ mb: 1, mt: 0.3 }} />
                </th>
              </tr>
            </thead>
            <tbody>
              {orderDetails.oProduct.map((item, index) => (
                <tr key={index}>
                  <td align="center">{++index}</td>
                  <td className="product-name">
                    <p>{item.productName}</p>
                  </td>
                  <td align="center">{item.qty}</td>
                  <td align="center">
                    <CurrencyRupeeRoundedIcon className="icon" />
                    {item.price}
                  </td>
                  <td align="center">
                    <CurrencyRupeeRoundedIcon className="icon" />
                    {item.qty * item.price}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5}>
                  <Box sx={{ mb: 5 }} />
                </td>
              </tr>
              <tr>
                <td colSpan={4} align="right">
                  <p>Subtotal</p>
                </td>
                <td colSpan={1} align="right">
                  <CurrencyRupeeRoundedIcon className="icon" />
                  {orderDetails.subTotal}
                </td>
              </tr>
              <tr>
                <td colSpan={4} align="right">
                  <p>Discount</p>
                </td>
                <td colSpan={1} align="right">
                  <CurrencyRupeeRoundedIcon className="icon" />
                  {orderDetails.discount}
                </td>
              </tr>
              {orderDetails.couponDiscount !== 0 && (
                <tr>
                  <td colSpan={4} align="right">
                    <p>Coupon Discount</p>
                  </td>
                  <td colSpan={1} align="right">
                    <CurrencyRupeeRoundedIcon className="icon" />
                    {orderDetails.couponDiscount}
                  </td>
                </tr>
              )}

              <tr>
                <td colSpan={4} align="right">
                  <p>Shipping</p>
                </td>
                <td colSpan={1} align="right">
                  Free
                </td>
              </tr>
              <tr>
                <td colSpan={4} align="right">
                  <b>Total</b>
                </td>
                <td colSpan={1} align="right">
                  <CurrencyRupeeRoundedIcon className="icon" />
                  <b>{orderDetails.total}</b>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div className="footer">
        <Divider />
        <p>Thank you for ordering with KRISTIVE.</p>
      </div>
    </div>
  );
};

export default InvoiceBill;
